@if (itemTypeDetail$ | async; as item) {
  <div class="emm-item-types-form">
    <form [formGroup]="form">
      <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
        <label class="mt-4">Name</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="name"
            type="text"
            placeholder="Name"
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-8-5vw flex-space-between-center flex-row">
        <label class="mt-4">Item&nbsp;Class&nbsp;Type</label>
        <mat-form-field class="flex-40" >
          <mat-select
            formControlName="classTag"
            type="select"
            placeholder="Select an Item Type Class"
            >
            @for (option of itemTypeClasses$ | async; track option) {
              <mat-option [value]="option.classTag">
                {{ option.className }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div    class="flex-gap-10vw flex-space-between-center flex-row">
        <label class="mt-4">Description</label>
        <mat-form-field class="flex-40" >
          <textarea matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            formControlName="description"
            type="text"
            placeholder="Description"
          ></textarea>
        </mat-form-field>
      </div>
    </form>
    @if (item.lastUpdatedBy || item.lastUpdatedDate) {
      <emm-attribute-updated-info
        [lastUpdatedBy]="item.lastUpdatedBy"
        [lastUpdatedDate]="item.lastUpdatedDate"
        class="updated-by"
      ></emm-attribute-updated-info>
    }
  </div>
}
